export default () => {
  return {
    transitionScale: "transition-all ease-in-out duration-400 hover:scale-105",
    transitionColour: "transition-all ease-in-out duration-400",
  };
};
